<template>
  <div>
    <div v-if="listDatas.length && listDatas.length >0">
      <div class="list-box" v-for="(listData,i) in listDatas" :key="i">
        <img :src="listData.goodsPicUrl" style="width:1.6rem;margin-right:0.2rem;" />
        <div class="content">
          <span class="title">{{listData.goodsName}}</span>
          <span class="order-id">订单编号 {{listData.mainOrderNo}}</span>
          <span class="order-time">下单时间 {{listData.orderCreated}}</span>
        </div>
        <div class="right">
          <span class="price">¥{{listData.price}}</span>
          <span
            :class="listData.orderStatus=='1' ? 'success' : 'return'"
          >{{listData.orderStatus=='1' ? '已完成' : '已退款'}}</span>
        </div>
      </div>
    </div>
    <div v-if="listDatas.length=='0'" class="no-data">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: "orderHome",
  data() {
    return {
      listDatas: [],
      taskId: "",
      channelType:""
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.taskId = this.$route.query.id;
      this.getList();
    }
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
  methods: {
    getList() {
      this.$api
        .taskOrderList({
          memberId: JSON.parse(sessionStorage.getItem("user")).memberId,
          taskId: this.taskId,
        })
        .then((res) => {
          if (res.errno === "0") {
            this.listDatas = res.data.body;
          } else {
            this.$toast(e.msg);
          }
          console.log("res", res);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-box {
  background: #fff;
  width: 90%;
  margin: auto;
  margin-top: 0.2rem;
  border-radius: 0.08rem;
  display: flex;
  height: 1.5rem;
  padding: 0.1rem 0rem 0.1rem 0.1rem;
}

.list-box img {
  flex: 1;
}

.list-box .content {
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.list-box .right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-end;
}

.title {
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 4rem;
  font-size: 0.28rem;
}

.order-id,
.order-time {
  color: #999;
  font-size: 0.2rem;
}

.price {
  color: #dd2b1e;
  display: inline-block;
  padding-right: 0.1rem;
  font-size: 0.3rem;
}

.success {
  color: #fff;
  display: inline-block;
  background: #00b095;
  font-size: 0.2rem;
  text-align: center;
  border-bottom-left-radius: 0.01rem;
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-bottom-left-radius: 0.1rem;
  border-top-left-radius: 0.1rem;
}

.return {
  color: #fff;
  display: inline-block;
  background: #ccc;
  font-size: 0.2rem;
  text-align: center;
  border-bottom-left-radius: 0.01rem;
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-bottom-left-radius: 0.1rem;
  border-top-left-radius: 0.1rem;
}

.no-data {
  text-align: center;
  margin-top: 1rem;
  color: #666;
}
</style>
